import {
  Autocomplete,
  Button,
  IconButton,
  Popover,
  TextField,
  Typography,
  Box,
  Divider,
  Chip,
  Paper,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import CustomSearchbar from "../custom-searchbar/CustomSearchbar";
import PropTypes from "prop-types";
import { useState } from "react";
import {
  CrossIconTask,
  PendingExport,
  PendingFilter,
} from "../../assets/common-svg/CommonSvg";
import { useFormik } from "formik";
import CustomDateRangePicker from "../custom-date-picker/CustomDateRangePicker";
import { PendingTasks } from "../../utils/formik/initialValues";
import CategoryTabs from "../custom-category-tab/CategoryTabs";
import { buildChips } from "./filterChips";
import { CloseIcon } from "../../bmr/assets/CommonSvg";



export const PendingTaskHeader = ({
  taskCount,
  handleGetHistoryData,
  alignment,
  setAlignment,
  setPage,
  SearchbarPlaceholder,
  handleSearch,
  value,
  disabled,
  handleExportButton = () => { },
  // requestData,
  rolesData = [],
  phaseData,
  productData,
  selectedCategory = [],
  handleFilterSubmit,
  setFilters,
  categoryTabs = [],
  onCategoryChange,
  showCategoryCount = false,
  onArchivedFilterChange,
  onSelectAll,
  isAllSelected = false,
  isClosed = false,
  isChangeRequestView = false,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [resetCount, setResetCount] = useState(0);
  const [activeFilterChips, setActiveFilterChips] = useState([]);
  const showCRTabs = isChangeRequestView;
  const isArchivedAlignment =
    alignment === "Archived CR" || alignment === "Archived Tasks";
  const currentStatus = alignment.includes("Pending") || isArchivedAlignment ? "0" : "1";
  const currentArchivedValue = isArchivedAlignment ? 1 : 0;

  const open = Boolean(anchorEl);

  // let leftCount = taskCount?.stats?.pending_count;
  // let RightCount = taskCount?.stats?.closed_count;

  const handleDateChange = (e) => {
    setSelectedDate(e);
  };

  const resetField = (chipKey) => ({
    ...(chipKey === "role" && { role: null }),
    ...(chipKey === "product" && { product: null }),
    ...(chipKey === "phase_id" && { phase_id: null }),
  });
  const formik = useFormik({
    initialValues: PendingTasks,
    onSubmit: (values) => {
      handleFilterSubmit(values, selectedDate);
      setActiveFilterChips(buildChips({ values, selectedDate, rolesData, productData, phaseData }));
      handlePopoverClose();
    },
  });

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const handleRemoveChip = (chipKey) => {
    const updatedValues = { ...formik.values, ...resetField(chipKey) };
    const updatedDate = chipKey === "date" ? null : selectedDate;

    formik.setValues(updatedValues);
    if (chipKey === "date") setSelectedDate(null);

    const updatedChips = buildChips({
      values: updatedValues,
      selectedDate: updatedDate,
      rolesData, productData, phaseData,
    });
    setActiveFilterChips(updatedChips);

    if (updatedChips.length === 0) {
      setFilters({});
      handleGetHistoryData(currentStatus, {}, false, 1, selectedCategory, currentArchivedValue);
    } else {
      handleFilterSubmit(updatedValues, updatedDate);
    }
  };

  const handleClearFilter = () => {
    setSelectedDate(null);
    setFilters({});
    formik.resetForm();
    setActiveFilterChips([]);
    setResetCount((prev) => prev + 1); // Increment to trigger reset
    // if (onArchivedFilterChange) onArchivedFilterChange(null);
    handleGetHistoryData(currentStatus, {}, false, 1, selectedCategory, currentArchivedValue);
    handlePopoverClose();
  };

  const handleSelectAllChange = (event) => {
    if (onSelectAll) {
      onSelectAll(event.target.checked);
    }
  };
  const ChipDeleteIcon = (props) => (
    <span
      {...props}
      style={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        fontSize: 12,
        color: "#828282",
        marginRight: "6px",
        marginLeft: "2px",
      }}
    >
      <CloseIcon
        className="text-[#828282] hover:text-black"
        style={{ fontSize: 12 }}
      />
    </span>
  );
  return (
    <div className="w-full grid lg:grid-cols-12 gap-4 relative">
      <div className="col-start-1 col-end-7 sm:col-end-4 w-100">
        {handleSearch && (
          <CustomSearchbar
            value={value}
            Placeholder={SearchbarPlaceholder}
            handleSearch={handleSearch}
            disabled={disabled}
          />
        )}
      </div>
      <div className="col-start-7 sm:col-start-4 col-end-13 flex justify-end items-center gap-2 relative">
        {!showCRTabs && (
          <div className="flex items-center gap-1 bg-gray-100 rounded-full p-1">
            {[
              { label: "Pending Tasks", count: taskCount?.stats?.pending_count, value: "Pending Tasks" },
              { label: "Closed Tasks", count: taskCount?.stats?.closed_count, value: "Closed Tasks" },
              { label: "Archived Tasks", count: taskCount?.stats?.archived_count, value: "Archived Tasks" },
            ].map((tab) => {
              const isActive = alignment === tab.value;
              return (
                <button
                  key={tab.value}
                  onClick={() => {
                    setAlignment(tab.value);
                    setPage(1);
                    if (tab.value === "Archived Tasks") {
                      onArchivedFilterChange?.(1);
                    } else {
                      onArchivedFilterChange?.(0);
                    }
                  }}
                  style={{
                    background: isActive ? "#2563EB" : "#DFE0EB",
                    color: isActive ? "#fff" : "#6b7280",
                    border: "none",
                    borderRadius: "0.625rem",
                    padding: "8px 16px",
                    fontSize: "15px",
                    fontWeight: 500,
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                >
                  {tab.label}{tab.count != null ? ` (${tab.count})` : ""}
                </button>
              );
            })}
          </div>
        )}
        {showCRTabs && (
          <div className="flex items-center gap-1 bg-gray-100 rounded-full p-1">
            {[
              { label: "Pending CR", count: taskCount?.stats?.pending_count, value: "Pending CR" },
              { label: "Approved/Rejected CR", count: taskCount?.stats?.closed_count, value: "Approved/Rejected CR" },
              { label: "Archived CR", count: taskCount?.stats?.archived_count, value: "Archived CR" },
            ].map((tab) => {
              const isActive = alignment === tab.value;
              return (
                <button
                  key={tab.value}
                  onClick={() => {
                    setAlignment(tab.value);
                    setPage(1);
                    if (tab.value === "Archived CR") {
                      onArchivedFilterChange?.(1);
                    } else {
                      onArchivedFilterChange?.(0);
                    }
                  }}
                  style={{
                    background: isActive ? "#2563EB" : "#DFE0EB",
                    color: isActive ? "#fff" : "#6b7280",
                    border: "none",
                    borderRadius: "0.625rem",
                    padding: "8px 16px",
                    fontSize: "15px",
                    fontWeight: 500,
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                >
                  {tab.label}{tab.count != null ? ` (${tab.count})` : ""}
                </button>
              );
            })}
          </div>
        )}

        {/* )} */}
        {showCRTabs && (
          <IconButton
            disableRipple
            aria-label="filter"
            className="bg-white h-10 w-10 ml-4 rounded-[10px]"
            onClick={handleExportButton}
          >
            <PendingExport />
          </IconButton>
        )}
        <IconButton
          disableRipple
          aria-label="filter"
          className="bg-white h-10 w-10 ml-2 rounded-[10px]"
          onClick={handlePopoverOpen}
        >
          <PendingFilter />
        </IconButton>

        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          PaperProps={{
            sx: {
              p: 2,
              width: 400,
              maxWidth: "90vw",
              borderRadius: "10px",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
            },
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{ mb: 2 }}
          >
            <Typography variant="h6">Filter</Typography>
            <IconButton onClick={handlePopoverClose} size="small">
              <CrossIconTask />
            </IconButton>
          </Box>
          <Divider />
          <Box sx={{ "& > *": { mb: 2, pt: 2 } }}>
            <form
              onSubmit={formik.handleSubmit}
              className="flex flex-col gap-4"
            >
              <div className="custom-task-form">
                <Typography variant="inherit" component="label">
                  Roles
                </Typography>
                <Autocomplete
                  disablePortal
                  options={rolesData}
                  getOptionLabel={(option) => option.name}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  sx={{
                    width: "100%",
                    mt: 1,
                    "& .MuiAutocomplete-popupIndicator": {
                      transform: "translateY(-1px)", // Adjusts arrow position upward
                      "&:hover": {
                        backgroundColor: "transparent !important", // Removes hover bg color
                      },
                    },
                  }}
                  value={
                    rolesData?.find(
                      (res) => res.id === formik.values.role
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    formik.setFieldValue(
                      "role",
                      newValue ? newValue.id : null
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Role"
                      size="small"
                      onKeyDown={(e) => {
                        const inputValue = e.target.value;
                        if (e.key === " " && inputValue.length === 0) {
                          e.preventDefault();
                        }
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#f5f5f5",
                          borderRadius: "10px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderWidth: "0px",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderWidth: "0px",
                          },
                          "&:hover": {
                            backgroundColor: "#eeeeee",
                          },
                          "& .MuiOutlinedInput-input": {
                            padding: "8.5px 14px",
                            cursor: "pointer",
                          },
                        },
                      }}
                    />
                  )}
                />
              </div>
              {/* <div>
                <Typography variant="inherit" component="label">
                  Request Type
                </Typography>
                <Autocomplete
                  disablePortal
                  options={requestData}
                  getOptionLabel={(option) => option.name}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  sx={{
                    width: "100%",
                    mt: 1,
                    "& .MuiAutocomplete-popupIndicator": {
                      transform: "translateY(-1px)",
                      "&:hover": {
                        backgroundColor: "transparent !important",
                      },
                    },
                  }}
                  value={
                    requestData.find(
                      (res) => res.id === formik.values.category
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    formik.setFieldValue(
                      "category",
                      newValue ? newValue?.id : null
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Request Type"
                      size="small"
                      onKeyDown={(e) => {
                        const inputValue = e.target.value;
                        if (e.key === " " && inputValue.length === 0) {
                          e.preventDefault();
                        }
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#f5f5f5",
                          borderRadius: "10px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderWidth: "0px",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderWidth: "0px",
                          },
                          "&:hover": {
                            backgroundColor: "#eeeeee",
                          },
                          "& .MuiOutlinedInput-input": {
                            padding: "8.5px 14px",
                            cursor: "pointer",
                          },
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      {option.name}
                    </li>
                  )}
                />
              </div> */}

              <div>
                <Typography variant="inherit" component="label">
                  Product
                </Typography>
                <Autocomplete
                  disablePortal
                  options={productData}
                  getOptionLabel={(option) => option.name}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  sx={{
                    width: "100%",
                    mt: 1,
                    "& .MuiAutocomplete-popupIndicator": {
                      transform: "translateY(-1px)",
                      "&:hover": {
                        backgroundColor: "transparent !important",
                      },
                    },
                  }}
                  value={
                    productData.find(
                      (res) => res.id === formik.values.product
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    formik.setFieldValue(
                      "product",
                      newValue ? newValue?.id : null
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Product"
                      size="small"
                      onKeyDown={(e) => {
                        const inputValue = e.target.value;
                        if (e.key === " " && inputValue.length === 0) {
                          e.preventDefault();
                        }
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#f5f5f5",
                          borderRadius: "10px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderWidth: "0px",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderWidth: "0px",
                          },
                          "&:hover": {
                            backgroundColor: "#eeeeee",
                          },
                          "& .MuiOutlinedInput-input": {
                            padding: "8.5px 14px",
                            cursor: "pointer",
                          },
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      {option.name}
                    </li>
                  )}
                />
              </div>
              <div>
                <Typography variant="inherit" component="label">
                  Phase
                </Typography>
                <Autocomplete
                  disablePortal
                  options={phaseData}
                  getOptionLabel={(option) => option.name}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  sx={{
                    cursor: "pointer",
                    width: "100%",
                    mt: 1,
                    "& .MuiAutocomplete-popupIndicator": {
                      transform: "translateY(-1px)",
                      "&:hover": {
                        backgroundColor: "transparent !important",
                      },
                    },
                  }}
                  value={
                    phaseData.find((res) => res.id === formik.values.phase_id) ||
                    null
                  }
                  onChange={(event, newValue) => {
                    formik.setFieldValue(
                      "phase_id",
                      newValue ? newValue.id : null
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Phase"
                      size="small"
                      onKeyDown={(e) => {
                        const inputValue = e.target.value;
                        if (e.key === " " && inputValue.length === 0) {
                          e.preventDefault();
                        }
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#f5f5f5",
                          borderRadius: "10px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderWidth: "0px",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderWidth: "0px",
                          },
                          "&:hover": {
                            backgroundColor: "#eeeeee",
                          },
                          "& .MuiOutlinedInput-input": {
                            padding: "8.5px 14px",
                            cursor: "pointer",
                          },
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      {option.name}
                    </li>
                  )}
                />
              </div>
              <div>
                <Typography
                  variant="inherit"
                  component="label"
                  className="mb-2"
                >
                  Date Range
                </Typography>
                <CustomDateRangePicker
                  selectedDate={selectedDate ? selectedDate : null}
                  handleDateChange={handleDateChange}
                  months={1}
                  resetTrigger={resetCount}
                />
              </div>
              <Box display="flex" justifyContent="space-between">
                <Button
                  variant="outlined"
                  onClick={handleClearFilter}
                  sx={{ mr: 2 }}
                >
                  Clear Filter
                </Button>
                <Button variant="contained" type="submit">
                  Apply Filter
                </Button>
              </Box>
            </form>
          </Box>
        </Popover>
      </div>
      {activeFilterChips.length > 0 && (
        <div className="col-span-full">
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "10px",
              padding: "8px 12px",
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {activeFilterChips.map((chip) => (
              <Chip
                key={chip.key}
                label={
                  <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <span style={{ color: "#828282", fontWeight: 400 }}>
                      {chip.label}:
                    </span>
                    <span style={{ color: "#111", fontWeight: 400 }}>
                      {chip.value}
                    </span>
                  </span>
                }

                deleteIcon={<ChipDeleteIcon />}
                onDelete={() => handleRemoveChip(chip.key)}
                size="small"
                sx={{
                  backgroundColor: "#f0f0f0",
                  border: "1px solid #d0d0d0",
                  borderRadius: "6px",
                  fontSize: "0.8rem",
                  height: 30,
                  color: "#444",
                  maxWidth: "none",
                  paddingLeft: "4px",
                  paddingRight: "4px",
                  "& .MuiChip-label": {
                    paddingLeft: "8px",
                    paddingRight: "4px",
                  },
                  "& .MuiChip-deleteIcon": {
                    fontSize: "12px",
                    color: "#828282",
                    marginRight: "6px",
                    marginLeft: "2px",
                  },
                }}
              />
            ))}
            <Button
              size="small"
              variant="contained"
              onClick={handleClearFilter}
              sx={{ borderRadius: "6px", fontSize: "0.8rem", textTransform: "none", px: 2, height: 30 }}
            >
              Clear All
            </Button>
          </div>
        </div>
      )}
      <div className="col-span-full">
        <CategoryTabs
          title="Category"
          tabs={categoryTabs}
          selectedTab={selectedCategory}
          onTabChange={onCategoryChange}
          showCount={showCategoryCount}
          onClearAll={() => onCategoryChange?.([])}
        />
      </div>
      {!isClosed && (
        <div className="col-span-full ">
          <Paper
            elevation={0}
            sx={{
              backgroundColor: "white",
              borderRadius: "10px",
              border: "1px solid #e0e0e0",
              padding: "12px 20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 2,
            }}
          >

            <Box sx={{ display: "flex", alignItems: "center" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isAllSelected}
                    onChange={handleSelectAllChange}
                  />
                }
                label={
                  <Typography variant="body1" sx={{ fontWeight: 500, color: "#111" }}>
                    Select All
                  </Typography>
                }
              />

            </Box>
          </Paper>
        </div>
      )}
    </div>
    // </div>
  );
};

PendingTaskHeader.propTypes = {
  taskCount: PropTypes.object,
  handleGetHistoryData: PropTypes.func,
  alignment: PropTypes.string,
  setAlignment: PropTypes.func,
  setPage: PropTypes.func,
  SearchbarPlaceholder: PropTypes.string,
  handleSearch: PropTypes.func,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  handleExportButton: PropTypes.func,
  requestData: PropTypes.array,
  phaseData: PropTypes.array,
  productData: PropTypes.array,
  handleFilterSubmit: PropTypes.func,
  categoryTabs: PropTypes.array,
  selectedCategory: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  onCategoryChange: PropTypes.func,
  showCategoryCount: PropTypes.bool,
  onArchivedFilterChange: PropTypes.func,
  isClosed: PropTypes.bool,
};

export default PendingTaskHeader;
